export default __webpack_public_path__ + "static/media/bigLogo.5ac88c86.svg";